<template>
  <div>
    <!-- 설명 -->
    <p class="mb-5">
      ※ 관리감독자가 담당종사자를 직접 작성하는 페이지입니다. <br />
      ※ 사업장별 최초 작성 후 변동사항이 생겼을시 이전에 작성했던 문서를 열어 수정하여 저장합니다.
    </p>

    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" :types="fieldTypes" :typeslabel="fieldTypesLabel" />

    <!-- 종사자 현황 -->
    <table-custom :board="board" :is-print="isPrint" title="종사자 현황" :tableData="tableData" v-model="form.worker">
      <template #customTr>
        <tr style="background: #f9f9f9 !important">
          <td v-if="projectId !== 1 && projectId !== 3 && projectId !== 5"></td>
          <td></td>
          <td></td>
          <td class="text-center">소계</td>
          <td style="padding: 10px 15px">
            <comma-input readonly placeholder="자동입력" v-model="form.workerNum" class="w-full flex-1" />
          </td>
          <td></td>
        </tr>
      </template>
    </table-custom>
    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import TableCustom from "@/components/TableCustom";

export default {
  components: {
    FieldSelectModule,
    FileUploadModule,
    TableCustom,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  computed: {
    projectId() {
      return Number(this.$route.params.proj_id);
    },
    fieldTypesLabel() {
      switch (this.projectId) {
        case 1:
        case 3:
        case 5:
          return {
            field_name: "사업장명",
            department: "업체명",
            com_name: "부서명",
            rank: "직책",
            writer_name: "작성자",
            date: "최종수정일",
          };
        case 2:
          return {
            field_name: "사업장명",
            department: "소속명",
            com_name: "부서명",
            rank: "직책",
            writer_name: "작성자",
            date: "최종수정일",
          };
        case 4:
          return {
            field_name: "사업장명",
            department: "원청사명",
            com_name: "협력사명",
            rank: "직책",
            writer_name: "작성자",
            date: "최종수정일",
          };
      }
    },
    tableData() {
      switch (this.projectId) {
        case 2:
          return [
            { id: "input1", title: "No.", type: "no", vertical: "middle" },
            {
              id: "input5",
              title: "구분",
              type: "select",
              placeholder: "선택",
              selectData: [
                "사무직",
                "현업 - 청소 등 유지관리",
                "현업 - 도로의 유지·보수 종사자",
                "현업 - 환경미화종사자",
                "현업 - 폐기물 수거처리",
                "현업 - 공원·녹지 유지관리",
                "현업 - 산림조사·보호",
                "현업 - 조리시설",
                "현업",
                "노동자",
                "청원경찰",
                "기타",
              ],
            },
            {
              id: "input2",
              title: "직종",
              type: "select",
              placeholder: "선택",
              selectData: ["공무원", "공무직", " 임기제", "기간제", "근로자", "공공근로", "노인 일자리", "장애인 일자리", "지역공동체", "자활", "기타"],
            },
            {
              id: "input3",
              title: "인원수",
              type: "number",
              placeholder: "숫자입력",
            },
            { id: "input4", title: "비고", type: "text", placeholder: "입력" },
          ];
        case 1:
        case 3:
        case 5:
          return [
            { id: "input1", title: "No.", type: "no", vertical: "middle" },
            {
              id: "input5",
              title: "구분",
              type: "select",
              placeholder: "선택",
              selectData: ["관리감독자", "직원", "근로자", "기타"],
            },
            {
              id: "input3",
              title: "인원수",
              type: "number",
              placeholder: "숫자입력",
            },
            { id: "input4", title: "비고", type: "text", placeholder: "입력" },
          ];
        case 4:
          // case 5:
          return [
            { id: "input1", title: "No.", type: "no", vertical: "middle" },
            {
              id: "input5",
              title: "구분",
              type: "select",
              placeholder: "선택",
              selectData: ["관리감독자", "직원", "근로자", "기타"],
            },
            {
              id: "input2",
              title: "직종",
              type: "select",
              placeholder: "선택",
              selectData: ["감리단장", "감리원", "안전보건총괄책임자", "관리감독자", "직원", "근로자", "기타"],
            },
            {
              id: "input3",
              title: "인원수",
              type: "number",
              placeholder: "숫자입력",
            },
            { id: "input4", title: "비고", type: "text", placeholder: "입력" },
          ];
      }
    },
    fieldTypes() {
      switch (this.projectId) {
        case 2:
          return ["field_name", "department", "com_name", "rank", "writer_name", "updated_at"];
        case 3:
          return [
            "field_name",
            // "department",
            "com_name",
            "rank",
            "writer_name",
            "updated_at",
          ];
        case 4:
          return ["field_name", "department", "com_name", "rank", "writer_name", "updated_at"];
        case 5:
          return [
            "field_name",
            "department",
            // "com_name",
            "rank",
            "writer_name",
            "updated_at",
          ];
      }
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;

        // 상세내용 No. 추가
        if (0 < value.worker.length) {
          value.workerNum = value.worker.reduce((prev, _w) => {
            const n = Number(_w.input3 || 0);
            return n + prev;
          }, 0);
        } else value.workerNum = null;

        // 그래프처리
        value.summary = {
          종사자현황_부서: [],
          종사자현황_사업장: [],
          종사자현황_구분: [],
          종사자현황_직종: [],
          종사자현황_부서_구분: [],
          종사자현황_부서_구분_직종: [],
          종사자현황_사업장_구분: [],
          종사자현황_사업장_구분_직종: [],
          종사자현황_부서_사업장_구분_직종: [],
        };

        if (this.form.stdInfo) {
          const 부서 = this.form.stdInfo.com_name;
          const 사업장 = this.form.stdInfo.field_name;

          let total = 0;
          const totalObj = {
            구분: {},
            직종: {},
            부서_구분: {},
            부서_구분_직종: {},
            사업장_구분: {},
            사업장_구분_직종: {},
            부서_사업장_구분_직종: {},
          };
          for (const worker of value.worker) {
            const 구분 = worker.input5;
            const 직종 = worker.input2;
            const numOfMember = typeof worker.input3 === "string" ? Number(worker.input3) : 0;
            total += numOfMember;

            // 구분 또는 직종을 선택했을 경우에만 카운팅
            if (!totalObj["구분"][구분]) totalObj["구분"][구분] = 0;
            if (!totalObj["직종"][직종]) totalObj["직종"][직종] = 0;
            if (!totalObj["부서_구분"][`${부서}_${구분}`]) totalObj["부서_구분"][`${부서}_${구분}`] = 0;
            if (!totalObj["부서_구분_직종"][`${부서}_${구분}_${직종}`]) totalObj["부서_구분_직종"][`${부서}_${구분}_${직종}`] = 0;
            if (!totalObj["사업장_구분"][`${사업장}_${구분}`]) totalObj["사업장_구분"][`${사업장}_${구분}`] = 0;
            if (!totalObj["사업장_구분_직종"][`${사업장}_${구분}_${직종}`]) totalObj["사업장_구분_직종"][`${사업장}_${구분}_${직종}`] = 0;
            if (!totalObj["부서_사업장_구분_직종"][`${부서}_${사업장}_${구분}_${직종}`]) totalObj["부서_사업장_구분_직종"][`${부서}_${사업장}_${구분}_${직종}`] = 0;

            totalObj["구분"][구분] += numOfMember;
            totalObj["직종"][직종] += numOfMember;
            totalObj["부서_구분"][`${부서}_${구분}`] += numOfMember;
            totalObj["부서_구분_직종"][`${부서}_${구분}_${직종}`] += numOfMember;
            totalObj["사업장_구분"][`${사업장}_${구분}`] += numOfMember;
            totalObj["사업장_구분_직종"][`${사업장}_${구분}_${직종}`] += numOfMember;
            totalObj["부서_사업장_구분_직종"][`${부서}_${사업장}_${구분}_${직종}`] += numOfMember;
          }

          value.summary["종사자현황_부서"] = [{ [부서]: total }];
          value.summary["종사자현황_사업장"] = [{ [사업장]: total }];

          const _keys_구분 = Object.keys(totalObj["구분"]);
          for (const 구분 of _keys_구분) {
            value.summary["종사자현황_구분"].push({ [구분]: totalObj["구분"][구분] });
          }
          const _keys_직종 = Object.keys(totalObj["직종"]);
          for (const 직종 of _keys_직종) {
            value.summary["종사자현황_직종"].push({ [직종]: totalObj["직종"][직종] });
          }
          const _keys_부서_구분 = Object.keys(totalObj["부서_구분"]);
          for (const 부서_구분 of _keys_부서_구분) {
            value.summary["종사자현황_부서_구분"].push({ [부서_구분]: totalObj["부서_구분"][부서_구분] });
          }
          const _keys_부서_구분_직종 = Object.keys(totalObj["부서_구분_직종"]);
          for (const 부서_구분_직종 of _keys_부서_구분_직종) {
            value.summary["종사자현황_부서_구분_직종"].push({ [부서_구분_직종]: totalObj["부서_구분_직종"][부서_구분_직종] });
          }
          const _keys_사업장_구분 = Object.keys(totalObj["사업장_구분"]);
          for (const 사업장_구분 of _keys_사업장_구분) {
            value.summary["종사자현황_사업장_구분"].push({ [사업장_구분]: totalObj["사업장_구분"][사업장_구분] });
          }
          const _keys_사업장_구분_직종 = Object.keys(totalObj["사업장_구분_직종"]);
          for (const 사업장_구분_직종 of _keys_사업장_구분_직종) {
            value.summary["종사자현황_사업장_구분_직종"].push({ [사업장_구분_직종]: totalObj["사업장_구분_직종"][사업장_구분_직종] });
          }
          const _keys_부서_사업장_구분_직종 = Object.keys(totalObj["부서_사업장_구분_직종"]);
          for (const 부서_사업장_구분_직종 of _keys_부서_사업장_구분_직종) {
            value.summary["종사자현황_부서_사업장_구분_직종"].push({ [부서_사업장_구분_직종]: totalObj["부서_사업장_구분_직종"][부서_사업장_구분_직종] });
          }
        }

        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        fileList: [],
        worker: [],
        workerNum: null,
      },
    };
  },
  methods: {},
};
</script>

<style scoped lang="scss"></style>
